const data = [
    {
        id: 1,
        title: "MDB - Movie Database",
        slug: "mdb",
        info: "A movie database, to look for movies' and series' informations.",
        url: "https://mdb-moviedatabase.vercel.app/",
        git: "veggietable",
        image: "/img-mdb.png",
        altImg: "MDB - Movie Database",
        description: "Thanks to TMDB's API (The Movie Database), you can look for informations about the last movies and series on televisions.",
        code: [
            "Javascript",
            "Tailwind",
            "React.js",
            "Next.js 13",
        ],
        year: 2023
    },
    {
        id: 2,
        title: "Veggietable",
        slug: "veggietable",
        info: "To look for vegetarian recipes.",
        url: "https://dpdproject-veggietable.netlify.app",
        git: "veggietable",
        image: "/img-veggietable.png",
        altImg: "Veggietable",
        description: "Thanks to Spoonacular's APIs you can search and get informations about lots of vegetarian recipes",
        code: [
            "Javascript",
            "React.js",
            "APIContext",
            "React Router",
            "Framer Motion",
            "Sass",
        ],
        year: 2022
    },
    {
        id: 3,
        slug: "new-york-times-clone",
        title: "New York Times clone",
        info: "A clone of the New York Times' homepage",
        url: "https://dpdproject-nytclone.netlify.app",
        git: "nyt_clone",
        image: "/img-nytclone.png",
        altImg: "New York Times clone",
        description: "Thanks to NYT's public API, I created a clone of the homepage with the possibility to recreate some sections too.",
        code: [
            "Javascript",
            "React.js",
            "APIContext",
            "React Router"
        ],
        year: 2022
    },
    {
        id: 4,
        title: "Quality of Life",
        slug: "quality-of-life",
        info: "To look for data about the quality of life of cities all over the world",
        url: "https://dpdproject-lifequalityapp.netlify.app",
        git: "life_quality_project",
        image: "/img-qualitylife.png",
        altImg: "Life Quality App",
        description: "Thanks to Teleport APIs you can get some values about the quality of life of cities all over the world. Statistics included in the project are the Housing score, the Cost of Living score and the total score of the city on a scale from 0 to 100, with a brief description of the city itself.",
        code: [
            "Javascript",
            "React.js",
            "APIContext",
            "React Router",
        ],
        year: 2022
    },
]

export default data